export default [
    {
        path: '/purchase/:vehicleId',
        name: 'purchase',
        component: () =>
            import(/* webpackChunkName: "purchase" */ '@/views/purchase'),
        children: [
            {
                path: 'summary',
                name: 'summary',
                component: () =>
                    import(
                        /* webpackChunkName: "summary" */ '@/views/purchase/summary'
                    ),
            },
            {
                path: 'personal-details',
                name: 'personal-details',
                component: () =>
                    import(
                        /* webpackChunkName: "personal-details" */ '@/views/purchase/personal-details'
                    ),
            },
            {
                path: 'trade-in',
                name: 'trade-in',
                component: () =>
                    import(
                        /* webpackChunkName: "trade-in" */ '@/views/purchase/trade-in'
                    ),
            },
            {
                path: 'add-ons',
                name: 'add-ons',
                component: () =>
                    import(
                        /* webpackChunkName: "add-ons" */ '@/views/purchase/add-ons'
                    ),
            },
            {
                path: 'delivery-options',
                name: 'delivery-options',
                component: () =>
                    import(
                        /* webpackChunkName: "delivery-options" */ '@/views/purchase/delivery-options'
                    ),
            },
            {
                path: 'financing',
                name: 'financing',
                component: () =>
                    import(
                        /* webpackChunkName: "financing" */ '@/views/purchase/financing'
                    ),
            },
            {
                path: 'credit',
                name: 'credit',
                component: () =>
                    import(
                        /* webpackChunkName: "credit" */ '@/views/purchase/credit'
                    ),
            },
            {
                path: 'documents',
                name: 'documents',
                component: () =>
                    import(
                        /* webpackChunkName: "documents" */ '@/views/purchase/documents'
                    ),
            },
        ],
    },
];
